import { authHeader } from "../_helpers/authHeader.js";
import axios from "../_helpers/axiosInstance.js";

const updateProfile = async (firstName, lastName) => {
    await axios.put("useraccount/profile", {firstName, lastName}, {headers: authHeader()});
};

const changePassword = async (currentPassword, newPassword) => {
    await axios.post("useraccount/password/change", {currentPassword, newPassword}, {headers: authHeader()});
};

export const accountApi = {
    updateProfile,
    changePassword
};
